"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_CONFIG = {
    dxpWidgetUrl: process.env.REACT_APP_DXP_WIDGETS_BASE_PATH +
        (process.env.REACT_APP_COUNTRY + "/" + process.env.REACT_APP_BRAND_CODE + "/widgets/payment/dist/payment.esm.js"),
    dxpWidgetUrlWeb: process.env.REACT_APP_DXP_WIDGETS_BASE_PATH +
        (process.env.REACT_APP_COUNTRY + "/" + process.env.REACT_APP_BRAND_CODE + "/widgets/payment/dist/index.html"),
};
